import type {
  AdmissionGroup,
  AdmissionGroupSerialized,
} from '../admissionGroup'
import { AdmissionGroupReceiptType } from '../constants/admissionGroup'
import {
  getNormalizedPaymentLast4,
  getPaymentInstrumentDisplayLabel,
} from './paymentInstrumentDisplay'

const INTERNAL_PAYMENT_RECEIPT_TYPES = new Set<AdmissionGroupReceiptType>([
  AdmissionGroupReceiptType.INTERNAL,
  AdmissionGroupReceiptType.INTERNAL_AUTH,
])

function getInternalPaymentReceipt(
  admissionGroup: AdmissionGroup | AdmissionGroupSerialized
) {
  return admissionGroup.receipts?.find(
    (entry) => entry.type && INTERNAL_PAYMENT_RECEIPT_TYPES.has(entry.type)
  )
}

export function getAdmissionGroupReceiptCardLast4(
  admissionGroup: AdmissionGroup | AdmissionGroupSerialized
): string | undefined {
  const receipt = getInternalPaymentReceipt(admissionGroup)
  return getNormalizedPaymentLast4(receipt?.cardLast4)
}

export function getAdmissionGroupReceiptCardholderName(
  admissionGroup: AdmissionGroup | AdmissionGroupSerialized
): string | undefined {
  const receipt = getInternalPaymentReceipt(admissionGroup)
  const cardholderName = receipt?.cardName?.trim() || receipt?.userName?.trim()
  return cardholderName || undefined
}

export function getAdmissionGroupReceiptPaymentMethodLabel(
  admissionGroup: AdmissionGroup | AdmissionGroupSerialized
): string | undefined {
  const receipt = getInternalPaymentReceipt(admissionGroup)
  if (!receipt) return undefined

  return getPaymentInstrumentDisplayLabel({
    cardName: receipt.cardName,
    cardLast4: receipt.cardLast4,
    cardType: receipt.cardType,
    paymentMethodType: receipt.paymentMethodType,
    walletType: receipt.walletType,
  })
}
